import Component from '../abstracts/Component';
import { Select2Init } from "../utils/Select2Init";

export default class DataEnrichmentComponent extends Component {

  get SELECTORS() {
    return {
      registerCheckbox: '[data-js-register]',
      registerPassword: '[data-js-password]',
      passwordHint: '#password-hint',
      privacyCheckbox: '#privacy-checkbox',
      consents: '[data-js-consents]',
      submitBtn: '[data-js-submit]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      registerCheckbox: this.$component.querySelector(this.SELECTORS.registerCheckbox),
      registerPassword: this.$component.querySelector(this.SELECTORS.registerPassword),
      privacyCheckbox: this.$component.querySelector(this.SELECTORS.privacyCheckbox),
      passwordHint: this.$component.querySelector(this.SELECTORS.passwordHint),
      consents: this.$component.querySelector(this.SELECTORS.consents),
      submitBtn: this.$component.querySelector(this.SELECTORS.submitBtn),
      firstRadio: null,
      secondRadio: null
    };
  }

  handleRegister() {
    if(this.dom.registerCheckbox) {
      if (this.dom.registerPassword.querySelector('.--msg-error')) {
        this.dom.passwordHint.classList.add('hidden');
      }
      this.dom.registerCheckbox.addEventListener("change", event => {
        if(event.currentTarget.checked) {
          this.dom.registerPassword.classList.remove("hidden");
        } else {
          this.dom.registerPassword.classList.add("hidden");
        }
        if (this.dom.registerPassword.querySelector('.--msg-error')) {
          this.dom.passwordHint.classList.remove('hidden');
          this.dom.registerPassword.querySelector(".custom-input").classList.remove("error");
          this.dom.registerPassword.querySelector('.--msg-error').classList.add("hidden");
        }
        this.dom.registerPassword.querySelector("input").value = "";
      });
    }
  }

  handlePrivacy() {
    if(this.dom.privacyCheckbox) {
      const radios = this.dom.consents.querySelectorAll("input[type='radio']");

      this.dom.privacyCheckbox.addEventListener("change", event => {
        if(event.currentTarget.checked) {
          this.dom.consents ? this.dom.consents.classList.remove("disabled") : '';
          radios ? this.checkSubmit(radios, false) : '';
        } else {
          this.dom.consents ? this.dom.consents.classList.add("disabled"): '';
          radios ? this.checkSubmit(radios, true) : '';
          this.dom.submitBtn.disabled = true;
          this.dom.firstRadio = null;
          this.dom.secondRadio = null;
        }
      });
      radios.forEach((radio, index) => {
        radio.addEventListener("change", event => {
          if(index < 2) {
            this.dom.firstRadio = event.currentTarget;
          } else {
            this.dom.secondRadio = event.currentTarget;
          }
          if(this.dom.firstRadio && this.dom.secondRadio) {
            this.dom.submitBtn.disabled = false;
          }
        });
      });
    }
  }

  checkSubmit(radios,disabled) {
    radios.forEach(radio => {
      radio.disabled = disabled;
      radio.checked ?  radio.checked = !disabled : '';
    });
  }

  render() {
    super.render();
    this.log("Rendering...");
    this.dom = this.readDOM();
    this.handleRegister();
    this.handlePrivacy();
    Select2Init();
  }
}
